
















import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  PriceDto,
  ProductAttributeInfo,
  SalesConditionInfo,
  SalesConditionType
} from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';
import Nara from '@/domain/product/Nara';
import NaraIcons from '@/search-result/badges/NaraIcons.vue';
import ProductAttributeBadges from '@/search-result/badges/ProductAttributeBadges.vue';
import PriceIcons from '@/search-result/badges/PriceIcons.vue';
import FairPriceIcon from '@/search-result/badges/FairPriceIcon.vue';
import VirtualCategoryBadges from '@/search-result/badges/VirtualCategoryBadges.vue';

@Component({
  components: {VirtualCategoryBadges, FairPriceIcon, PriceIcons, ProductAttributeBadges, NaraIcons }
})
export default class ProductBadges extends Vue {
  @Prop({required: true})
  public sku: string;

  @Prop({required: true})
  public attributes: ProductAttributeInfo[];

  @Prop({required: true})
  public conditions: SalesConditionInfo[];

  @Prop({required: false, default: null})
  public currentPrice: PriceDto | null;

  @Prop({required: false, default: () => []})
  public naras: Nara[];

  @Prop({required: true, default: () => []})
  public virtualCategories: string[];

  get conditionClasses(): Array<{ info: SalesConditionInfo, class: string }> {
    return this.conditions.map((info) => {
      switch (info.key) {
        case SalesConditionType.New:
          return {info, class: 'p-badge-new'};
        default:
          return {info, class: 'p-badge'};
      }
    });
  }

  get hasDiscount(): boolean {
    return !!(this.currentPrice && this.currentPrice.attachedDiscount) &&
        ConfigService.isHighlightDiscounts();
  }
}
